export const normalizeCreateSection = (state, id, label) => [
	...state,
	{
		id,
		label,
		isCustom: true,
		instructions: [],
		count: 0
	}
];

export const normalizeEditSection = (state, id, label) =>
	state.map((section) => {
		if (section.id === id) {
			return {
				...section,
				id,
				label
			};
		}
		return section;
	});

export const normalizeDeleteSection = (state, id) => id !== null && state.filter((i) => i.id !== id);
